import { Component, OnInit, Input } from '@angular/core';
import { Konto } from 'src/app/api/konto';

@Component({
  selector: 'app-konto-card',
  templateUrl: './konto-card.component.html',
  styleUrls: ['./konto-card.component.scss']
})
export class KontoCardComponent implements OnInit {
  @Input() konto: Konto;
  public status: string;

  constructor() { }

  ngOnInit() {
    if (this.konto.typ === 'A') {
      this.status = 'danger';
    }
    else if (this.konto.typ === 'E') {
      this.status = 'primary';
    }
    else if (this.konto.typ === 'G') {
      this.status = 'success';
    }
  }

}
